import { Component, OnInit, Input,Output ,EventEmitter} from "@angular/core";

import { NofeshService } from "../../nofesh/nofesh.service";
import { IPrice } from "../../nofesh/model/price";

@Component({
    moduleId: module.id,
    templateUrl: './nofesh-prices.component.html',
    selector: 'nofesh-prices',
    providers:[NofeshService]
})

export class NofeshPricesComponent implements OnInit {

    constructor(private _http: NofeshService) { }

    @Output() onPricesChange :EventEmitter<IPrice[]>= new EventEmitter<IPrice[]>();
   
    prices: IPrice[];

    @Input() nofeshId: number;
   
   //wdsadsad
    ngOnInit() {
        this._http.getNofeshPrices(this.nofeshId)
            .subscribe(r => { this.prices = r; 
                this.onPricesChange.emit(this.prices);
            }, error => {
                if (error.includes("401")) {
                    localStorage.removeItem("token");
                    location.reload();
                }
            })

    }
}